import React, { useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams, updateWidgetSettings } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import "./settings.less";
import { useIntl } from "react-intl";
import { Input, Message, Switch, Button } from "../../../BP2Components";

const { Option } = Select;

const ListMapSettings = (props) => {
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      mapLocalizationFieldName: props.localizationFieldName,
      mapClickFilterColName: props.mapClickFilterColName,
      mapDefaultZoomLevel: props.defaultZoomLevel,
      mapViewListSerie: props.viewListSerie,
      mapListSerie: props.mapListSerie,
      mapIndependentSerie: props.mapIndependentSerie,
      mapPointColName: props.mapPointColName,
      mapDistanceColName: props.mapDistanceColName,
      mapAddressColName: props.mapAddressColName,
      showMap: props.showMap,
      columns: props.columns,
      showListName: props.showListName,
      filterByLocation: props.filterByLocation,
      distanceToFilter: props.distanceToFilter,
      maxDistanceToFilter: props.maxDistanceToFilter,
      setDistanceColumnHidden: props.setDistanceColumnHidden,
      name: props.name,
      columnProperties: props.columnProperties,
      selectedSerie: props.selectedSerie,
      listWidgetSeries: props.listWidgetSeries,
      priority: props.priority,
      stateChange: 0,
      id: props.id,
      xsWidth: props.xs,
      smWidth: props.sm,
      mdWidth: props.md,
      lgWidth: props.lg,
      xlWidth: props.xl,
      backgroundColourHex: props.backgroundColourHex,
      showPlacefinder: props.showPlacefinder,
      showUrlButton: props.showUrlButton,
      urlColumn: props.urlColumn,
      ulrButtonTitle: props.ulrButtonTitle,
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      dispatch(updateWidgetSettings(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChange = (e) => {
      let saveValue = e.target.value;
      if (Number.isInteger(+e.target.value)) {
         saveValue = +e.target.value;
      }
      setSettings({ ...settings, [e.target.name]: saveValue });
   };
   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };
   const handleSelect = (name, val) => {
      setSettings({ ...settings, [name]: val });
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="showMap" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showMap" />:
                     <Switch
                        name="showMap"
                        onChange={(e) => handleSwitch(e, "showMap")}
                        defaultChecked={props.showMap}
                     />
                  </label>
                  <label key="mapSerie" className="widget-settings__inner__label">
                     <IntlMessages id="settings.mapSerie" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapListSerie}
                        onChange={(val) => handleSelect("mapListSerie", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.listWidgetSeries &&
                           props.listWidgetSeries.map((serie) => {
                              return (
                                 <Option key={serie.name} value={serie.name}>
                                    {serie.name}
                                 </Option>
                              );
                           })}
                     </Select>
                  </label>
                  <label key="markerClickSerie" className="widget-settings__inner__label">
                     <IntlMessages id="settings.markerClickSerie" />:
                     <Select
                        className="input-200"
                        defaultValue={props.viewListSerie}
                        onChange={(val) => handleSelect("mapViewListSerie", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.listWidgetSeries &&
                           props.listWidgetSeries.map((serie) => {
                              return <Option value={serie.name}>{serie.name}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="mapIndependentSerie">
                     <IntlMessages id="settings.mapIndependentSerie" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapIndependentSerie}
                        onChange={(val) => handleSelect("mapIndependentSerie", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.listWidgetSeries &&
                           props.listWidgetSeries.map((serie) => {
                              return <Option value={serie.name}>{serie.name}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="mapClickFilterColName">
                     <IntlMessages id="settings.mapClickFilterColName" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapClickFilterColName}
                        onChange={(val) => handleSelect("mapClickFilterColName", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.columns &&
                           props.columns.map((col) => {
                              return <Option value={col.dataIndex}>{col.dataIndex}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="localizationFieldName">
                     <IntlMessages id="settings.localizationFieldName" />:
                     <Select
                        className="input-200"
                        defaultValue={props.localizationFieldName}
                        onChange={(val) => handleSelect("mapLocalizationFieldName", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.columns &&
                           props.columns.map((col) => {
                              return <Option value={col.label}>{col.label}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="mapPointColName">
                     <IntlMessages id="settings.mapPointColName" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapPointColName}
                        onChange={(val) => handleSelect("mapPointColName", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.columns &&
                           props.columns.map((col) => {
                              return <Option value={col.label}>{col.label}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="mapAddressColName">
                     <IntlMessages id="settings.mapAddressColName" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapAddressColName}
                        onChange={(val) => handleSelect("mapAddressColName", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.columns &&
                           props.columns.map((col) => {
                              return <Option value={col.label}>{col.label}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="mapDistanceColName">
                     <IntlMessages id="settings.mapDistanceColName" />:
                     <Select
                        className="input-200"
                        defaultValue={props.mapDistanceColName}
                        onChange={(val) => handleSelect("mapDistanceColName", val)}
                     >
                        <Option value={"-"}>{"-"}</Option>
                        {props.columns &&
                           props.columns.map((col) => {
                              return <Option value={col.label}>{col.label}</Option>;
                           })}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" key="defaultZoomLevel">
                     <IntlMessages id="settings.defaultZoomLevel" />:
                     <Input
                        type="text"
                        name="mapDefaultZoomLevel"
                        style={{ width: "200px" }}
                        onChange={handleChange}
                        defaultValue={props.defaultZoomLevel}
                     />
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default ListMapSettings;
